import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type CartState = {
  totalItems: number;
  totalPrice: number;
  type: "guest" | "user";
  variantIds: number[];
  isLoaded: boolean;
};

const initialState: CartState = {
  totalItems: 0,
  totalPrice: 0,
  type: "guest",
  variantIds: [],
  isLoaded: false,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setCartSummary: (
      state,
      action: PayloadAction<{
        totalItems: number;
        totalPrice: number;
        type: "guest" | "user";
        variantIds?: number[];
      }>
    ) => {
      state.totalItems = action.payload.totalItems;
      state.totalPrice = action.payload.totalPrice;
      state.type = action.payload.type;
      state.variantIds = action.payload.variantIds ?? [];
      state.isLoaded = true;
    },
    clearCartSummary: (state) => {
      state.totalItems = 0;
      state.totalPrice = 0;
      state.type = "guest";
      state.variantIds = [];
      state.isLoaded = true;
    },
    addGuestCartPreviewItem: (state) => {
      state.totalItems += 1;
      state.type = "guest";
      state.isLoaded = true;
    },
  },
});

export const {
  addGuestCartPreviewItem,
  setCartSummary,
  clearCartSummary,
} = cartSlice.actions;

export default cartSlice.reducer;
